import { Card, Flex, Typography } from "antd";

const { Text } = Typography;

interface Stat {
	label: string;
	value: React.ReactNode;
}

interface StatsBarProps {
	stats: Stat[];
	className?: string;
	cardClassName?: string;
	valueClassName?: string;
	labelClassName?: string;
}

export const StatsBar = ({
	stats,
	className,
	cardClassName,
	valueClassName,
	labelClassName,
}: StatsBarProps) => (
	<Flex className={className}>
		{stats.map((s) => (
			<Card key={s.label} size="small" className={cardClassName}>
				<Text className={valueClassName}>{s.value}</Text>
				<Text className={labelClassName}>{s.label}</Text>
			</Card>
		))}
	</Flex>
);
